<div  style="height: 100vh;">
<app-adminmenu *ngIf="desosuserinfo.blnIsAdmin"></app-adminmenu>
<app-usersmenu *ngIf="desosuserinfo.blnIsDESOSManager"></app-usersmenu>
<app-usersmenu *ngIf="desosuserinfo.blnIsUser"></app-usersmenu>
<div class="bg-light shadow-lg">
  <router-outlet #routerOutlet="outlet"></router-outlet>
</div>
<app-footer></app-footer>
</div>
